(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DreamWhisperDesignSnapshot = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  function create({ colors, regions, palette, paletteVersion, regionSchemaVersion }) {
    const byId = new Map((palette || []).map(color => [color.id, color]));
    const missing = (regions || []).filter(region => !colors?.[region.id]);
    if (missing.length) throw new Error('Choose a color for ' + missing.map(region => region.name).join(', ') + '.');
    const design = (regions || []).map((region, index) => {
      const color = byId.get(colors[region.id]);
      if (!color) throw new Error(colors[region.id] + ' is not an approved color.');
      if (color.sellable !== true || /preview-only|pending|demo/i.test(color.status || '')) {
        throw new Error(color.id + ' is preview-only and cannot be ordered.');
      }
      return {
        id: region.id,
        name: region.name,
        colorId: color.id,
        colorCode: color.code || color.id,
        colorName: color.name,
        hex: color.hex
      };
    });
    const snapshot = {
      product: 'Dream Whisper',
      paletteVersion: paletteVersion || 'unspecified',
      regionSchemaVersion: regionSchemaVersion || 'unspecified',
      regions: design
    };
    const properties = {
      _dw_palette_version: snapshot.paletteVersion,
      _dw_region_schema_version: snapshot.regionSchemaVersion,
      _dw_preview_note: 'Flat color placement guide; finished wool texture and shades may vary.'
    };
    design.forEach((region, index) => {
      const label = 'Color ' + String(index + 1).padStart(2, '0') + ' - ' + region.name;
      properties[label] = region.colorCode + ' · ' + region.colorName;
    });
    properties._dw_design = JSON.stringify(snapshot);
    return { snapshot, properties };
  }
  function restore(properties) {
    let snapshot = null;
    try { snapshot = JSON.parse(properties?._dw_design || 'null'); } catch (_) { /* legacy line item */ }
    if (snapshot && Array.isArray(snapshot.regions)) {
      return {
        colors: Object.fromEntries(snapshot.regions.map(region => [region.id, region.colorId])),
        paletteVersion: snapshot.paletteVersion,
        regionSchemaVersion: snapshot.regionSchemaVersion,
        snapshot
      };
    }
    const colors = {};
    Object.entries(properties || {}).forEach(([key, value]) => {
      const match = key.match(/^Color\s+\d+\s+-\s+.+\s+\(([^)]+)\)$/);
      const colorId = String(value || '').split(' · ')[0];
      if (match && colorId) colors[match[1]] = colorId;
    });
    return { colors, paletteVersion: properties?._dw_palette_version || properties?.['Palette version'] || '', regionSchemaVersion: properties?._dw_region_schema_version || properties?.['Region schema version'] || '', snapshot: null };
  }
  return { create, restore };
});
